import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";

// audiosprite --e "mp3" --o ../assets/audio/audiosprite *.mp3

export class AudioManager {
    
    public static audioSpriteManager: Phaser.Sound.WebAudioSoundManager;

    public static init(): void {
        
        AudioManager.audioSpriteManager = new Phaser.Sound.WebAudioSoundManager(GameVars.currentScene.game);
        AudioManager.audioSpriteManager.mute = GameVars.gameData.muted;
    }

    public static toggleAudioState(): void {

        GameVars.gameData.muted = !GameVars.gameData.muted;
        GameManager.writeGameData();
        AudioManager.audioSpriteManager.mute = GameVars.gameData.muted;     
    }

    public static SetVolume(newVolume: number) {

        this.audioSpriteManager.setVolume(newVolume); 
    }
    
    public static playSound(key: string, loop?: boolean, volume?: number): void {

        loop = loop || false;       
        AudioManager.audioSpriteManager.playAudioSprite("audio-sprite", key, { loop: loop });
    }

    public static stopSound(key: string, fade?: boolean, loop?: boolean): void {

        if (key === null || typeof key === "undefined") {
            return;
        }
        
        AudioManager.audioSpriteManager.remove(new Phaser.Sound.BaseSound(AudioManager.audioSpriteManager, key));
    }
}
